<template>
  <div>
    <div slot="title">
      <h2> Recepción </h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <nav class="row">
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link" data-toggle="tab" href="#nav-demandas" role="tab" aria-controls="nav-home" aria-selected="false" @click="TabChange">Demandas</a>
                <a class="nav-item nav-link" data-toggle="tab" href="#nav-promociones" role="tab" aria-controls="nav-profile" aria-selected="false" @click="TabChange">Promociones</a>
                <a class="nav-item nav-link active" data-toggle="tab" href="#nav-oficios-otrosdocumentos" role="tab" aria-controls="nav-contact" aria-selected="true" @click="TabChange">Oficios / Otros Documentos</a>
              </div>
              <div>
                <div class="form-group" style="margin: 0px;">
                  <label style="margin: 10px;"><strong>LEYENDAS:</strong></label>
                  <input type="button" value="Cancelado" v-on:click="ImprimeLeyenda('CANCELADO')">
                  <input type="button" value="Reimpresión" v-on:click="ImprimeLeyenda('REIMPRESION')">
                  <input type="button" value="Anexos" v-on:click="ImprimeLeyenda('ANEXOS')">
                  <input type="button" value="Redireccionado" v-on:click="ImprimeLeyenda('REDIRECCIONADO')">
                </div>
              </div>
              <div class="form-check" style="margin: 5px;">
                <input class="form-check-input" id="chbFolio" type="checkbox" v-on:click="LimpiarFolio" v-model="BuscarFolio">
                <label class="form-check-label" for="chbFolio">
                  Folio
                </label>
                
              </div>
              <div v-if="BuscarFolio" class="row mt-2">
                <div class="form-group col-6 mb-0">
                  <input type="text" class="form-control" v-on:keydown="validarFolio" v-model="Folio_aBuscar">
                </div>
                <button class="btn btn-primary col-1" @click="EliminarFolio" id="btnEliminar"><i class="fas fa-trash-alt"></i></button>
              </div>
            </nav>
            <div class="tab-content row mt-4" id="nav-tabContent">
              <div class="tab-pane fade " id="nav-demandas" role="tabpanel" aria-labelledby="nav-home-tab">
                <form class="d-flex flex-wrap">
                  <div class="col-12 area">
                    <div class="row">
                      <div class="col-6 form-group d-flex">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="1" id="a" value="Civil" v-on:click="cambioMateria" v-model="picked">
                          <label class="form-check-label" for="a">Civil</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="2" id="b" value="Mercantil" v-on:click="cambioMateria" v-model="picked">
                          <label class="form-check-label" for="b">Mercantil</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="3" id="c" value="Familiar" v-on:click="cambioMateria" v-model="picked">
                          <label class="form-check-label" for="c">Familiar</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="4" id="d" value="Contencioso" v-on:click="cambioMateria" v-model="picked">
                          <label class="form-check-label" for="d">Contencioso</label>
                        </div>
                        <!-- <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="5" id="e" value="Laboral" v-on:click="cambioMateria" v-model="picked">
                          <label class="form-check-label" for="e">Laboral</label>remot
                          
                        </div> -->
                        <div v-if="picked !== 'Contencioso' && picked !== 'Laboral'" class="form-check col-8">
                          <input class="form-check-input position-static" type="checkbox" id="checkDirecta" v-model="AsignarDirectamente" v-on:click="modificaAreasDirectas" value="option1" aria-label="...">
                          <label class="form-check-label" for="inlineCheckbox1">Asignación Directa</label>
                          <div id="areaDirectaDiv" style="display:none">
                            <AreasRecepcion :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeAsignacionDirecta" :idDelInput="'areaDirecta'" :parametros="parametros_Asig.parametros" :valorDefinido="parametros_Asig.IdArea" :key="parametros_Asig.key" :idOrden="parametros_Asig.Ordenamiento"></AreasRecepcion>
                          </div>
                        </div>
                      </div>
                      <div v-if="picked === 'Contencioso'" class="form-group-h col-6">
                        <div>
                          <label for="exampleInputEmail1">Juicio</label>
                          <div class="form-group">
                            <select id="JuicioCon" class="form-control">
                              <option value="1">Lesividad</option>
                              <option value="2">Nulidad</option>
                              <option value="3">Responsabilidad Patrimonial del Estado</option>
                              <option value="90">Sistema Anticorrupción</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 mb-3">
                        <div v-if="picked !== 'Contencioso'" class="form-check form-check-inline">
                          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                          <label class="form-check-label" for="inlineCheckbox1">Incompetencia</label>
                        </div>
                        <div v-if="picked !== 'Contencioso'" class="form-check form-check-inline">
                          <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" v-model="destinoMunicipios">
                          <label class="form-check-label" for="inlineCheckbox2">Destino (Municipios)</label>
                          <Municipios v-if="destinoMunicipios" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioAreaMunicipios" :idDelInput="'areaDirecta'" :parametros="parametros_Municipios.parametros" :valorDefinido="parametros_Municipios.IdArea" :key="parametros_Municipios.key" :filtro="true"></Municipios>
                        </div>
                      </div>
                      <div v-if="picked === 'Civil' || picked === 'Contencioso'" class="form-group col-6">
                        <label v-if="picked !== 'Contencioso'" for="exampleInputEmail1">Acto o Res. Impugnado</label>
                        <label v-if="picked === 'Contencioso'" for="exampleFormControlSelect1">Acto Impugnado</label>
                        <C042JuiciosTemisCivil :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :materia="picked" v-on:valorParaElPadre="cambioDeJuicio" :idDelInput="'juicioDemandaCivCon'" :valorDefinido="parametros_Juicio.juicioId" :key="parametros_Juicio.key" v-on:keyup.enter="enfocarElemento" ref="juicioDemandaCivCon"></C042JuiciosTemisCivil>
                      </div>
                      <div v-if="picked === 'Mercantil' || picked === 'Familiar' || picked === 'Laboral'" class="form-group col-6">
                        <label for="exampleInputEmail1">Naturaleza del Juicio</label>
                        <C042JuiciosTemisCivil :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :materia="picked" v-on:valorParaElPadre="cambioDeJuicio" :idDelInput="'juicioDemandaMercFam'" :valorDefinido="parametros_Juicio.juicioId" :key="parametros_Juicio.key" v-on:keyup.enter="enfocarElemento" ref="juicioDemandaMercFam"></C042JuiciosTemisCivil>
                      </div>
                      <div v-if="picked !== 'Familiar'" class="form-group col-4">
                        <label for="exampleInputPassword1">Cantidad</label>
                        <input type="text" class="form-control" v-on:keydown="SoloNumeros" v-model="Cant">
                      </div>
                      <div v-if="picked !== 'Familiar'" class="form-group col-2">
                        <label for="exampleFormControlSelect1">Unidad</label>
                        <select class="form-control" id="seleccionarCambio" v-on:change="EstablceTipoCambio">
                          <option value="1">M.N</option>
                          <option value="2">DLL</option>
                          <option value="3">UDIS</option>
                          <option value="4">EURO</option>
                        </select>
                      </div>
                      <div v-if="picked === 'Civil'" class="form-group col-6">
                        <label for="exampleFormControlSelect1">Tipo de Act. o Res. Imp</label>
                        <C046TramitesTemisCivil :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeTramite" :idDelInput="'tramiteDemandaCiv'" :valorDefinido="parametros_Tramite.tramiteId" :key="parametros_Tramite.key" v-on:keyup.enter="enfocarElemento" ref="tramiteDemandaCiv"></C046TramitesTemisCivil>
                      </div>
                      <div v-if="picked === 'Mercantil' || picked === 'Familiar' || picked === 'Contencioso' || picked === 'Laboral'" class="form-group col-6">
                        <label v-if="picked !== 'Contencioso'" for="exampleInputEmail1">Objeto del Juicio</label>
                        <label v-if="picked === 'Contencioso'" for="exampleFormControlSelect1">Acto Específico</label>
                        <C046TramitesTemisCivil :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeTramite" :idDelInput="'tramiteDemandaMercFam'" :valorDefinido="parametros_Tramite.tramiteId" :key="parametros_Tramite.key" v-on:keyup.enter="enfocarElemento" ref="tramiteDemandaMercFam"></C046TramitesTemisCivil>
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect1">Presenta</label>
                        <input type="text" class="form-control" id="presDema" v-model="preDem" v-on:keyup.enter="enfocarElemento">
                      </div>
                      <div class="col-12">
                        <div class="row">
                          <div class="col-3 form-group">
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="inlineRadioOptions1" id="radioActor" value="Actor" v-on:click="cambioPersonalidad" v-model="radioPersonalidad">
                              <label class="form-check-label" for="inlineRadio5">Actor</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="inlineRadioOptions1" id="radioDeman" value="Demandado" v-on:click="cambioPersonalidad" v-model="radioPersonalidad">
                              <label class="form-check-label" for="inlineRadio6">Demandado</label>
                            </div>
                            <div v-if="picked == 'Contencioso'" class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="inlineRadioOptions1" id="radioTerce" value="Tercero" v-on:click="cambioPersonalidad" v-model="radioPersonalidad">
                              <label class="form-check-label" for="inlineRadio7">Tercero</label>
                            </div>
                          </div>
                          <div class="col-6 form-group">
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="persFisica" value="Fisica" v-on:click="cambioPersona" v-model="radioPersona">
                              <label class="form-check-label" for="inlineRadio8">Física</label>
                            </div>
                            <div v-if="picked !== 'Familiar'" class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="persMoral" value="Moral" v-on:click="cambioPersona" v-model="radioPersona">
                              <label class="form-check-label" for="inlineRadio9">Moral</label>
                            </div>
                            <div v-if="picked === 'Contencioso'" class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="inlineRadioOptions2" id="persAutor" value="Autoridad" v-on:click="cambioPersona" v-model="radioPersona">
                              <label class="form-check-label" for="inlineRadio10">Autoridad</label>
                            </div>
                            <div id="div_municipiosAutoridad" class="form-check form-check-inline" style="display:none;">
                              <Municipios :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioMunicipio" :idDelInput="'municipio'" :parametros="parametros_Municipios.parametros" :valorDefinido="parametros_Municipios.areaId" :filro="false"></Municipios>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" v-if="radioPersona == 'Autoridad'">
                        <div class="col-4">
                          <TiposInstitucion :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioAutoridad" :idDelInput="'tipoInstitucion'" :valorDefinido="parametros_TipoInstitucion.TipoInstNombre" :key="parametros_TipoInstitucion.key" ref="tipoInstitucionCon"></TiposInstitucion>
                        </div>
                        <div class="col-4">
                          <Autoridades :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioCargo" :idDelInput="'autoridad'" :parametros="parametros_Autoridad.parametros" :valorDefinido="parametros_Autoridad.AutoridadId" :key="parametros_Autoridad.key"></Autoridades>
                        </div>
                        <div class="col-4">
                          <Cargos :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'cargo'" :parametros="parametros_Cargos.parametros" :valorDefinido="parametros_Cargos.CargoId" :key="parametros_Autoridad.key"></Cargos>
                        </div>
                      </div>
                      <div class="form-group col-4" v-if="radioPersona != 'Autoridad'">
                        <label for="exampleInputPassword1">Nombre</label>
                        <input type="text" class="form-control" id="nombreDema" v-on:keyup.enter="enfocarElemento">
                      </div>
                      <div class="form-group col-4" v-if="radioPersona != 'Autoridad'">
                        <label for="exampleInputPassword1" id="demaLap">Apellido Paterno</label>
                        <input type="text" class="form-control" id="apatDema" v-on:keyup.enter="enfocarElemento">
                      </div>
                      <div class="form-group col-4" v-if="radioPersona != 'Autoridad'">
                        <label for="exampleInputPassword1" id="demaLam">Apellido Materno</label>
                        <input type="text" class="form-control" id="amatDema" v-on:keyup.enter="AgregaElementoTabla('tablaPersonalidades', 'persona', '', false)">
                      </div>
                      <div class="form-group col-6 ">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <h4 class="mr-3">Personalidades</h4>
                          </div>
                          <div class="form-group col-12">
                            <button type="button" class="btn btn-primary" @click="AgregaElementoTabla('tablaPersonalidades', 'persona', '', false, null)"><i class="fas fa-plus"></i></button>
                            <button type="button" class="btn btn-primary" @click="QuitaElementoTabla('tablaPersonalidades')"><i class="fas fa-minus"></i></button>
                          </div>
                          <div class="col-12">
                            <table class="table table-hover table-striped table-dark" id="tablaPersonalidades">
                              <thead>
                                <tr>
                                  <th scope="col">Tipo Persona</th>
                                  <th scope="col">Nombre</th>
                                  <th scope="col">Apellido Paterno</th>
                                  <th scope="col">Apellido Materno</th>
                                </tr>
                              </thead>
                              <tbody></tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-6 ">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <h4>Anexos</h4>
                          </div>
                          <div class="form-group col-3">
                            <button type="button" class="btn btn-primary" @click="AgregaElementoTabla('anexDema', 'cmb_anexosDema', 'cantAnexDema', false, null)"><i class="fas fa-plus"></i></button>
                            <button type="button" class="btn btn-primary" @click="QuitaElementoTabla('anexDema')"><i class="fas fa-minus"></i></button>
                          </div>
                          <div class="form-group col-2">
                            <input type="text" id="cantAnexDema" class="w-100" v-on:keydown="SoloNumeros" v-on:keyup.enter="enfocarElemento"/>
                          </div>
                          <div class="form-group col-7">
                            <C051Anexos :placeholder="'Seleccione un Anexo'" v-on:valorParaElPadre="cambioDeAnexo" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'cmb_anexosDema'" :key="parametros_Anexo.key" v-on:keyup.enter="enfocarElemento" ref="cmb_anexosDema"></C051Anexos>
                          </div>
                          <div class="col-12">
                            <table class="table table-hover table-striped table-dark" id="anexDema">
                              <thead>
                                <tr>
                                  <th scope="col">Descripción</th>
                                  <th scope="col">Cantidad</th>
                                </tr>
                              </thead>
                              <tbody></tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-12">
                        <label for="exampleInputPassword1">Observaciones</label>
                        <input type="text" class="form-control" id="obserDema" v-model="obsDem">
                      </div>
                      <div>
                        <button type="button" class="btn btn-outline-light" v-on:click="GuardarDocumento" id="btnGuardar"><i class="fas fa-save"></i>Guardar</button>
                        <button type="button" class="btn btn-outline-light" v-on:click="LimpiarControles"><i class="fas fa-eraser"></i> Limpiar</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="tab-pane fade" id="nav-promociones" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="col-12 area">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label for="exampleInputEmail1">Área</label>
                        <AreasPromocion :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioAreaPromocion" :idDelInput="'areaSeleccionada'" :parametros="parametros_AreaPromocion.parametros" :valorDefinido="parametros_AreaPromocion.areaPromoId" :key="parametros_AreaPromocion.key" :idOrden="enumeraciones.TipoOrden.Materia"></AreasPromocion>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="exampleInputEmail1">Número de Expediente</label>
                    </div>
                    <div class="col-1">
                      <div>
                        <input type="text" class="form-control" v-model="ConPromo" v-on:keydown="validarCapturaNumero" id="ConsecutivoPromocion">
                      </div>
                    </div>
                      <h4><strong>/</strong></h4>
                    <div class="col-1">
                      <div>
                        <input type="text" class="form-control" v-model="AnioPromo" v-on:keydown="validarCapturaNumero" id="AnioPromocion">
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="exampleInputEmail1">Tipo de Promoción</label>
                        <TiposPromocion :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeTipoPromo" :idDelInput="'tipoPomocion'" :valorDefinido="parametros_TipoPromo.TipoId" :key="parametros_TipoPromo.key" ref="tipoPomocion"></TiposPromocion>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="exampleInputPassword1">Presenta</label>
                        <input type="text" class="form-control" id="presProm" v-model="preProm" v-on:keyup.enter="enfocarElemento">
                      </div>
                    </div>
                    <div class="form-group col-6 ">
                      <div class="row">
                        <div class="col-12 d-flex">
                          <h4>Anexos</h4>
                        </div>
                        <div class="form-group col-3">
                          <button class="btn btn-primary" @click="AgregaElementoTabla('anexPromo', 'cmb_anexosPromo', 'cantAnexProm', false, null)"><i class="fas fa-plus"></i></button>
                          <button class="btn btn-primary" @click="QuitaElementoTabla('anexPromo')"><i class="fas fa-minus"></i></button>
                        </div>
                        <div class="form-group col-2">
                          <input type="text" id="cantAnexProm" class="w-100"  v-on:keydown="SoloNumeros"/>
                        </div>
                        <div class="form-group col-7">
                          <C051Anexos :placeholder="'Seleccione un Anexo'" v-on:valorParaElPadre="cambioDeAnexo" :tipo="enumeraciones.tiposDeSelect.Seleccione"  :idDelInput="'cmb_anexosPromo'" :key="parametros_Anexo.key" ref="cmb_anexosPromo"></C051Anexos>
                        </div>
                        <div class="col-12">
                          <table class="table table-hover table-striped table-dark" id="anexPromo">
                            <thead>
                              <tr>
                                <th scope="col">Descripción</th>
                                <th scope="col">Cantidad</th>
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-6">
                      <div class="row">
                        <div class="col-12 d-flex mb-2 pb-4">
                          <h4>Personalidades del Expediente Principal</h4>
                        </div>
                        <div class="col-12">
                          <table class="table table-hover table-striped table-dark" id="tablaPromociones">
                            <thead>
                              <tr>
                                <th scope="col">Tipo Persona</th>
                                <th scope="col">Nombre Completo</th>
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <label for="exampleInputPassword1">Observaciones</label>
                      <input type="text" class="form-control" v-model="obsProm">
                    </div>
                    <div>
                      <button type="button" class="btn btn-outline-light" @click="GuardarDocumento" id="btnGuardar"><i class="fas fa-save"></i>Guardar</button>
                      <button type="button" class="btn btn-outline-light" v-on:click="LimpiarControles"><i class="fas fa-eraser"></i> Limpiar</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show active" id="nav-oficios-otrosdocumentos" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="col-12 area">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label for="exampleInputEmail1">Tipo de Documento</label>
                        <TiposMensajeria :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeTipoMensajeria" :idDelInput="'tipoMensajeria'" :valorDefinido="parametros_TipoMensajeria.TipoId" :key="parametros_TipoMensajeria.key"></TiposMensajeria>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="exampleInputPassword1">Presenta</label>
                        <input type="text" class="form-control" id="presOfi" v-model="preOfiOtro"  v-on:keyup.enter="enfocarElemento">
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label for="exampleInputEmail1">Origen</label>
                        <AreaOrigenOficio :placeholder="'Seleccione un Area'" v-on:valorParaElPadre="cambioDeAreaOrigen" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'cmb_origenOficio'" :key="parametros_OrigenOficio.key" ref="cmb_origenOficio"></AreaOrigenOficio>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <label for="exampleInputEmail1">Destino</label>
                        <AreasRecepcion :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.etiquetasDeHTML.Select" v-on:valorParaElPadre="cambioDeArea" :parametros="parametros_Area.parametros" :valorDefinido="parametros_Area.areaId" :key="parametros_Area.key" :idOrden="enumeraciones.TipoOrden.Materia"></AreasRecepcion>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="form-group">
                        <label for="exampleInputPassword1">Número de Oficio</label>
                        <input type="text" class="form-control" v-model="numOfi">
                      </div>
                    </div>
                    <div class="form-group col-6">
                      <div class="row">
                        <div class="col-12 d-flex">
                          <h4>Anexos</h4>
                        </div>
                        <div class="form-group col-3">
                          <button class="btn btn-primary" @click="AgregaElementoTabla('anexOficio', 'cmb_anexOficio', 'cantAnexOfi', false, null)"><i class="fas fa-plus"></i></button>
                          <button class="btn btn-primary" @click="QuitaElementoTabla('anexOficio')"><i class="fas fa-minus"></i></button>
                        </div>
                        <div class="form-group col-2">
                          <input type="text" id="cantAnexOfi" class="w-100"  v-on:keydown="SoloNumeros"/>
                        </div>
                        <div class="form-group col-7">
                          <C051Anexos :placeholder="'Seleccione un Anexo'" v-on:valorParaElPadre="cambioDeAnexo" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'cmb_anexOficio'" :key="parametros_Anexo.key" ref="cmb_anexOficio"></C051Anexos>
                        </div>
                        <div class="col-12">
                          <table class="table table-hover table-striped table-dark" id="anexOficio">
                            <thead>
                              <tr>
                                <th scope="col">Descripción</th>
                                <th scope="col">Cantidad</th>
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <label for="exampleInputPassword1">Observaciones</label>
                      <input type="text" class="form-control" v-model="obsOfiOtro">
                    </div>
                    <div>
                      <button type="button" class="btn btn-outline-light" @click="GuardarDocumento" id="btnGuardar"><i class="fas fa-save"></i>Guardar</button>
                      <button type="button" class="btn btn-outline-light" v-on:click="LimpiarControles"><i class="fas fa-eraser"></i> Limpiar</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/components/TemisCivil/Comun/Plantilla.vue';
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        parametros_Juicio: {
          key: "",
          juicioId: -1,
          parametros: {}
        },
        parametros_TipoPromo: {
          key: "",
          TipoId: 1,
          parametros: {}
        },
        parametros_TipoMensajeria: {
          key: "",
          TipoId: -1,
          parametros: {}
        },
        parametros_Anexo: {
          key: "",
          anexoId: -1,
          parametros: {},
          NombreSeleccion: ""
        },
        parametros_OrigenOficio: {
          key: "",
          origenId: -1,
          parametros: {},
          NombreSeleccion: ""
        },
        parametros_Tramite: {
          key: "",
          tramiteId: -1,
          juicioId: -1,
          parametros: {}
        },
        parametros_Area:{
          key: "",
          areaId: -1,
          Ordenamiento: 1,
          parametros: {}
        },
        parametros_AreaPromocion:{
          key: "",
          areaPromoId: 1,
          OrdenamientoPromo: 1,
          parametros: {}
        },
        parametros_Asig:{
          key: "",
          areaId: -1,
          parametros: {}
        },
        parametros_Municipios:{
          //key: "",
          areaId: -1,
          parametros: {}
        },
        parametros_TipoDocumento: {
          key: "",
          tipoDocumentoId: -1,
          parametros: {
            SistemaId: 4 //EQUITAS
          }
        },
        parametros_Autoridad: {
          key: "",
          TipoId: 1,
          AutoridadId: -1,
          parametros: {}
        },
        parametros_TipoInstitucion:{
          key: "",
          TipoId: 1,
          TipoInstNombre: '',
        },
        parametros_Cargos:{
          key: "",
          TipoId: 1,
          CargoId: -1,
        },
        picked: 'Familiar',
        tipoPromo: 1,
        tipoMensajeria: 0,
        tipoDoc: 0,
        tab: 'oficios',
        enumeraciones,
        catalogos,
        comun,
        Pendientes: [],
        RangoDeTiempo: false,
        HoraDeDigitalizacion: false,
        PorZona: true,
        PorEnvio: false,
        PorTiempo: false,
        obsDem: '',
        obsProm: '',
        obsOfiOtro: '',
        preDem: '',
        preProm: '',
        preOfiOtro: '',
        NumDocumentoProm: '',
        ConPromo: '',
        AnioPromo: '',
        AuxNumDocu: '',
        IdEquiDocPadre: '',
        Cant:0,
        JuicioId:0,
        TramiteId:0,
        Cambio:1,
        AreaAsignada:0,
        AsignacionDirecta:0,
        AsignarDirectamente:false,
        OrigenOficio:'',
        numOfi:'',
        BuscarFolio:false,
        Folio_aBuscar:null,
        radioPersonalidad:'Actor',
        radioPersona:'Fisica',
        p_v:'',
        destinoMunicipios:false,
        MunicipioAsignado:0,
        Autoridad:0,
        TipoInst: '',
        Cargo:0,
        CambioVisibilidad:false,
        NombreInstitucion:''
      }
    },
    components: {
      Layout,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C042JuiciosTemisCivil: catalogos.PJ.C042JuiciosTemisCivil,
      C046TramitesTemisCivil: catalogos.PJ.C046TramitesTemisCivil,
      C051Anexos: catalogos.PJ.C051Anexos,
      TiposPromocion: catalogos.TemisCivil.TiposPromocion,
      TiposMensajeria: catalogos.TemisCivil.TiposMensajeria,
      AreasRecepcion: catalogos.TemisCivil.AreasRecepcion,
      AreasPromocion: catalogos.TemisCivil.AreasPromocion,
      AreaOrigenOficio: catalogos.TemisCivil.OrigenOficio,
      TiposInstitucion: catalogos.TemisCivil.TiposInstitucion,
      Autoridades: catalogos.TemisCivil.Autoridades,
      Cargos: catalogos.TemisCivil.Cargos,
      Municipios: catalogos.TemisCivil.Municipios,
    },
    computed:{
    },
    methods: {
      //Datos Obtención y demás
      cambioMateria: function (event){
        //Actualizo selección
        this.picked = event.currentTarget.value;
        //Actualizo parametros de juicio para volver a cargar componente
        this.parametros_Juicio.parametros.materiaId = event.currentTarget.value;
        this.parametros_Juicio.key = "Materia_" + event.currentTarget.value;
        if(this.AsignarDirectamente)
          this.AsignarDirectamente = false;
        if(document.getElementById('div_municipiosAutoridad'))
          document.getElementById('div_municipiosAutoridad').style.display = 'none';
        this.LimpiarControles();
      },
      cambioTipoInstitucion: function(datos){
        let valorSeleccionado = '';
        if((typeof datos) == "string")
          valorSeleccionado = datos;
        else
          valorSeleccionado = datos.target.value;
        var d = new Date();
        this.TipoInst = valorSeleccionado;
        this.parametros_TipoInstitucion.key = "TipoInst_" + d.getMilliseconds();
        this.parametros_Autoridad.key = "Autoridad_" + d.getMilliseconds();
      },
      cambioAutoridad: function(datos){
        let valor = "";
        if(typeof(datos) == "string")
          valor = datos;
        else
          valor = datos.target.value;
        if(valor == 'MUNICIPAL')
        {
          document.getElementById('div_municipiosAutoridad').style.display = '';
        }
        else
        {
          document.getElementById('div_municipiosAutoridad').style.display = 'none';
          this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerMunicipio", { llave: 'municipios', valor: '' });
        }
        this.parametros_Autoridad.TipoId = valor;
        this.parametros_Autoridad.key = "Autoridad_" + valor;
        this.Autoridad = this.parametros_Autoridad.AutoridadId;
      },
      cambioCargo: function(datos){
        var d = new Date();
        this.parametros_Cargos.key = "Cargo_" + d.getMilliseconds();
      },
      cambioMunicipio: function(datos){
        var d = new Date();
        this.MunicipioAsignado = this.parametros_Municipios.IdArea;
        this.parametros_Autoridad.key = "Autoridad_" + d.getMilliseconds();
      },
      cambioPersonalidad: function (event){
        if(this.radioPersona != "Autoridad")
        {
          document.getElementById('nombreDema').value = '';
          document.getElementById('apatDema').value = '';
          document.getElementById('amatDema').value = '';
        }
      },
      cambioPersona: function (event){
        this.radioPersona = event.currentTarget.value;
        if(document.getElementById('div_municipiosAutoridad'))
          document.getElementById('div_municipiosAutoridad').style.display = 'none';
        if(this.radioPersona == 'Moral')
        {//Nos esperamos a que esté cargado el el elemento antes de esconderlo
          let clock = setInterval(() => {
            clearInterval(clock)
            clock = null            
            document.getElementById('apatDema').style.display = 'none';
            document.getElementById('amatDema').style.display = 'none';
            document.getElementById('demaLap').style.display = 'none';
            document.getElementById('demaLam').style.display = 'none';
          }, 200)
        }
        if(this.radioPersona == 'Fisica')
        {//Nos esperamos a que esté cargado el el elemento antes de mostrarlo
          let clock = setInterval(() => {
            clearInterval(clock)
            clock = null            
            document.getElementById('apatDema').style.display = 'block';
            document.getElementById('amatDema').style.display = 'block';
            document.getElementById('demaLap').style.display = 'block';
            document.getElementById('demaLam').style.display = 'block';
          }, 200)
        }
        if(this.radioPersona == "Autoridad")
        {
          document.getElementById('nombreDema').value = '';
          document.getElementById('apatDema').value = '';
          document.getElementById('amatDema').value = '';
        }
      },
      recargaElemento(idElemento){
        var container = document.getElementById(idElemento);
        var content = container.innerHTML;
        container.innerHTML= content;
        container.innerText = "";
        container.value = "";
      },
      TabChange: function (event){
        let activa = event.target.outerText;
        if(activa == 'Demandas')
        {
          this.recargaElemento("cantAnexProm");
          this.recargaElemento("cantAnexOfi");
          this.tab = 'demanda';
        }
        if(activa == 'Promociones')
        {
          this.recargaElemento("cantAnexDema");
          this.recargaElemento("cantAnexOfi");
          this.tab = 'promociones';
        }
        if(activa == 'Oficios / Otros Documentos')
        {
          this.recargaElemento("cantAnexDema");
          this.recargaElemento("cantAnexProm");
          this.tab = 'oficios';
        }
        this.LimpiarControles();
      },
      cambioDeTipoPromo(datos){
        var id = 0;
        var d = new Date();
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_TipoPromo.TipoId = parseInt(id);
        this.tipoPromo = this.parametros_TipoPromo.TipoId;
      },
      cambioDeTipoMensajeria(datos){
        var id = 0;
        var d = new Date();
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_TipoMensajeria.TipoId = parseInt(id);
        this.tipoMensajeria = this.parametros_TipoMensajeria.TipoId;
      },
      cambioDeJuicio(datos){
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        //Actualizo Juicio
        this.parametros_Juicio.juicioId = parseInt(id);
        this.JuicioId = this.parametros_Juicio.juicioId;
        //Actualizo Trámite
        this.parametros_Tramite.juicioId = parseInt(id);
        this.parametros_Tramite.key = "Juicio_" + id;
      },
      cambioDeAnexo(datos){
        this.parametros_Anexo.anexoId = datos.AnexoId;
        this.parametros_Anexo.NombreSeleccion = datos.Nombre;
      },
      cambioDeAreaOrigen(datos){
        this.parametros_OrigenOficio.origenId = datos.AreaID;
        this.parametros_Anexo.NombreSeleccion = datos.Descripcion;
        this.OrigenOficio = datos.Descripcion;
      },
      cambioDeTramite(datos){
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_Tramite.tramiteId = parseInt(id);
        this.parametros_Tramite.key = "Juicio_" + this.parametros_Juicio.juicioId;
        this.TramiteId = this.parametros_Tramite.tramiteId;
      },
      cambioDeArea(datos) {
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_Area.areaId = parseInt(id);
        this.AreaAsignada = this.parametros_Area.areaId;
        this.$emit("cambioDeArea",datos);
      },
      cambioAreaMunicipios(datos){
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_Municipios.areaId = parseInt(id);
        this.MunicipioAsignado = this.parametros_Municipios.areaId;
        this.$emit("cambioDeArea",datos);
      },
      cambioAreaPromocion(datos){
        if(datos != undefined)
        {
          var d = new Date();
          var id = 0;
          if(isNaN(datos))
          {
            if(datos.target == null)
              id = -1;
            else
              id = parseInt(datos.target.value);
          }
          else
            id = parseInt(datos);
          //this.parametros_AreaPromocion.key = "AreaPromo_" + d.getMilliseconds();
          this.parametros_AreaPromocion.areaPromoId = parseInt(id);
          this.AreaAsignada = this.parametros_AreaPromocion.areaPromoId;
          this.$emit("cambioAreaPromocion",datos);
        }
      },
      cambioDeAsignacionDirecta(datos){
        if(isNaN(datos))
        {
          this.parametros_Asig.areaId = parseInt(datos.target.value);
          this.AsignacionDirecta = this.parametros_Asig.areaId;
          this.$emit("cambioDeAsignacionDirecta",datos);
        }
      },
      cambioDeOrigen(datos){
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_Area.areaId = parseInt(id);
        this.OrigenOficio = this.parametros_Area.areaId;
      },
      cambioDocumento(datos){
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_TipoDocumento.tipoDocumentoId = parseInt(id);
        this.tipoDoc = this.parametros_TipoDocumento.tipoDocumentoId;
      },
      modificaAreasDirectas(datos){
        var d = new Date();
        this.parametros_Asig.key = "Asignacion_" + d.getMilliseconds();
        if(this.picked == 'Civil')
          this.parametros_Asig.Ordenamiento = 22;
        if(this.picked == 'Mercantil')
          this.parametros_Asig.Ordenamiento = 23;
        if(this.picked == 'Familiar')
          this.parametros_Asig.Ordenamiento = 24;
        if(!this.AsignarDirectamente)
          this.ValidarPermiso();
        else
          document.getElementById("areaDirectaDiv").style.display = "none";
      },
      enfocarElemento:function(e){
        if(e.which == 13){//Si no es enter ignoramos el evento
          var gatillo = e.currentTarget.id;
          var enfocar ="";
          if(this.tab == 'demanda')
          {
            if(gatillo == 'juicioDemandaCivCon')
            {
              enfocar = '';
              this.$refs.tramiteDemandaCivCon.focus();
            }
            else if(gatillo == 'juicioDemandaMercFam')
            {
              enfocar = "tramiteDemandaMercFam";
            }
            else if(gatillo == 'tramiteDemandaCiv' || gatillo == 'tramiteDemandaMercFam')
            {
              enfocar = "presDema";
            }
            else if(gatillo == 'presDema')
            {
              enfocar = "nombreDema";
            }
            else if(gatillo == 'nombreDema')
            {
              if(this.radioPersona == 'Moral')
              {
                this.AgregaElementoTabla('tablaPersonalidades', 'persona', '', false, null);
              }else
              {
                enfocar = "apatDema";
              }
            }else if(gatillo == 'apatDema')
            {
              enfocar = "amatDema";
            }else if(gatillo == 'cantAnexDema')
            {
              enfocar = "cmb_anexosDema";
            }else if(gatillo == 'cmb_anexosDema')
            {
              enfocar = "obserDema";
            }
          }else if(this.tab == 'promociones')
          {
            if(gatillo == 'presProm')
            {
              enfocar = "cmb_anexosPromo"; 
            }
          }else if(this.tab == 'oficios')
          {
            if(gatillo == 'presOfi')
            {
              enfocar = "oriOfi";
            }
          }
          if(enfocar != "")
          {
            document.getElementById(enfocar).focus();
          }
        }
      },
      ValidarPermiso(){
          let peticion = {
              EsPrueba:false
          }
          axios.post(api.conexion + api.TemisCivil.sistema.Oficialia.AsignacionDirecta, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
              .then(respuesta => {
                if (respuesta.data.SiHayError) {
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {
                  if (respuesta.data.Satisfactorio != "") {
                    this.p_v = respuesta.data.ClaveValida;
                    if(this.p_v == '')
                    {
                      document.getElementById("areaDirectaDiv").style.display = "block";
                    }
                    else
                    {
                      let ingresarClave = window.prompt("Se necesita autorización:","");
                      if (ingresarClave == null || ingresarClave == "")
                      {
                        comun.mensajeDeAlerta("Información incorrecta", null, null);
                        this.AsignarDirectamente = false;
                        document.getElementById("areaDirectaDiv").style.display = "none";
                      }else if(ingresarClave == this.p_v)
                      {
                        document.getElementById("areaDirectaDiv").style.display = "block";
                      }else
                      {
                        comun.mensajeDeAlerta("Información incorrecta", null, null);
                        this.AsignarDirectamente = false;
                        document.getElementById("areaDirectaDiv").style.display = "none";
                      }
                    }
                  }
                }
              })
              .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
              })
      },
      ImprimeLeyenda(etiqueta){
            const OBTENER_STREAM = `${api.conexion}${api.TemisCivil.sistema.Oficialia.Impresionleyendas}?Leyenda=${etiqueta}`;
            try {
                axios.get(OBTENER_STREAM, { responseType: 'blob' })
                  .then(respuesta => {
                      const pdfWindow = window.open(URL.createObjectURL(new Blob([respuesta.data], {type: 'application/pdf'})), '_blank').print();
                  })
                  .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                 })
            }
            catch(exeption) {
              console.log(exeption);
            }
      },
      ImprimeRecibo(folio){
            const OBTENER_STREAM = `${api.conexion}${api.TemisCivil.sistema.Oficialia.ImpresionRecibos}?Folio=${folio}`;
            try {
                axios.get(OBTENER_STREAM, { responseType: 'blob' })
                  .then(respuesta => {
                      const pdfWindow = window.open(URL.createObjectURL(new Blob([respuesta.data], {type: 'application/pdf'})), '_blank').print();
                  })
                  .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                 })
            }
            catch(exeption) {
              console.log(exeption);
            }
      },
      LimpiarTablas(tablas_aVaciar){
        //Tablas
          for (var i = 0, len = tablas_aVaciar.length; i < len; i++)
          {
            var tableRef = document.getElementById(tablas_aVaciar[i]);
            while ( tableRef.rows.length > 1 )
            {
              tableRef.deleteRow(1);
            }
          }
      },
      EstablceTipoCambio(valorCambio){
        this.Cambio = valorCambio;
      },
      LimpiarControles(){
          var d = new Date();
          var tablas_aLimpiar = null;
          this.radioPersona = 'Fisica';
          this.BuscarFolio = false;
          if(this.tab == 'demanda')
          {
            if(document.getElementById('nombreDema') != null)
              document.getElementById('nombreDema').value = '';
            if(document.getElementById('apatDema') != null)
              document.getElementById('apatDema').value = '';
            if(document.getElementById('amatDema') != null)
              document.getElementById('amatDema').value = '';
            if(document.getElementById('cantAnexDema') != null)
              document.getElementById('cantAnexDema').value = '';
            tablas_aLimpiar = ['tablaPersonalidades', 'anexDema'];
            this.preDem = '';
            this.obsDem = '';
            this.Cant = 0;
            document.getElementById('radioActor').checked = true;
            this.ConPromo = '';
            this.AnioPromo = '';
            this.AsignarDirectamente = false;
            if(document.getElementById('areaDirectaDiv') != null)
              document.getElementById("areaDirectaDiv").style.display = "none";
          }
          if(this.tab == 'promociones')
          {
            this.picked = 'Familiar';
            this.parametros_TipoPromo.TipoId = -1;
            this.parametros_TipoPromo.key = "TipoPromo_Flush_" + d.getMilliseconds();
            tablas_aLimpiar = ['tablaPromociones', 'anexPromo'];
            this.NumDocumentoProm = '';
            if(document.getElementById('cantAnexProm') != null)
              document.getElementById('cantAnexProm').value = '';
            this.preProm = '';
            this.obsProm = '';
            this.ConPromo = '';
            this.AnioPromo = '';
          }
          if(this.tab == 'oficios')
          {
            this.picked = 'Familiar';
            this.parametros_TipoMensajeria.TipoId = -1;
            this.parametros_TipoMensajeria.key = "TipoMens_Flush_" + d.getMilliseconds();
            tablas_aLimpiar = ['anexOficio'];
            if(document.getElementById('cantAnexOfi') != null)
              document.getElementById('cantAnexOfi').value = '';
            this.OrigenOficio = '';
            this.numOfi = '';
            this.preOfiOtro = '';
            this.obsOfiOtro = '';
            this.ConPromo = '';
            this.AnioPromo = '';
          }
          //Selects
          this.parametros_Area.areaId = -1;
          this.parametros_Area.key = "Area_Flush_" + d.getMilliseconds();
          this.parametros_Anexo.anexoId = -1;
          this.parametros_Anexo.key = "Anexo_Flush_" + d.getMilliseconds();
          //Tablas
          for (var i = 0, len = tablas_aLimpiar.length; i < len; i++)
          {
            var tableRef = document.getElementById(tablas_aLimpiar[i]);
            while ( tableRef.rows.length > 1 )
            {
              tableRef.deleteRow(1);
            }
          }
      },
      SoloNumeros: function(e){
        if(isNaN(e.key) && e.which != 13 && e.which != 8)//que sea numérico, ENTER o BACKSPACE
        {
          e.preventDefault();
        }
      },
      ValidaCampos(){
        let correcto = true;
        let mensaje = "Los siguientes campos son requeridos:\n";

        if(this.tab == 'demanda')
        {
          if(!this.preDem){
            correcto = false;
            mensaje += "Presenta\n";
          }
          if(this.parametros_Juicio.juicioId == -1){
            correcto = false;
            mensaje += "Juicio\n";
          }
          if(document.getElementById('tablaPersonalidades').rows.length <= 1){
            correcto = false;
            mensaje += "Personalidades\n";
          }
          if(document.getElementById('anexDema').rows.length <= 1){
            correcto = false;
            mensaje += "Anexos\n";
          }
        }
        else if(this.tab == 'promociones')
        {
          if(this.tipoPromo == -1){
            correcto = false;
            mensaje += "Tipo Promoción\n";
          }
          if(document.getElementById('tablaPromociones').rows.length <= 1){
            correcto = false;
            mensaje += "Personalidades\n";
          }
          if(document.getElementById('anexPromo').rows.length <= 1){
            correcto = false;
            mensaje += "Anexos\n";
          }
          if(!this.preProm){
            correcto = false;
            mensaje += "Presenta\n";
          }
          if(!this.NumDocumentoProm){
            correcto = false;
            mensaje += "Expediente\n";
          }
        }
        else if(this.tab == 'oficios')
        {
          if(this.parametros_TipoMensajeria.TipoId == -1){
            correcto = false;
            mensaje += "Tipo de Documento\n";
          }
          if(document.getElementById('anexOficio').rows.length <= 1){
            correcto = false;
            mensaje += "Anexos\n";
          }
          if(!this.preOfiOtro){
            correcto = false;
            mensaje += "Presenta\n";
          }
          if(this.numOfi.length <= 0){
            correcto = false;
            mensaje += "Número de Oficio\n";
          }
          if(!this.OrigenOficio){
            correcto = false;
            mensaje += "Orígen\n";
          }
        }
        if(!correcto)
          comun.mensajeDeAlerta(mensaje, null, null);
        return correcto;
      },
      //Solicitar Permisos para edición de un folio
      EditaFolio(){
            let peticion = {
              IdEqui:0
            }
          axios.post(api.conexion + api.TemisCivil.sistema.Oficialia.Eliminar, peticion)
              .then(respuesta => {
                if (respuesta.data.SiHayError) {
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {
                  if (respuesta.data.Satisfactorio != "") {
                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                  }
                }
              })
              .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
              })
          },
      //Tablas
      DatosPersonalidad(){
        var apat = '';
        var amat = '';
        var nombre = '';
        var nombreCompleto = '';
        var tipo1 = document.getElementById('radioActor').checked ? 'ACTOR' : (document.getElementById('radioDeman').checked ? 'DEMANDADO' : (document.getElementById('radioTerce').checked ? 'TERCERO': 'X'));
        var tipo2 = document.getElementById('persFisica').checked ? 'F' : (document.getElementById('persMoral').checked ? 'M' : (document.getElementById('persAutor').checked ? 'A': 'X'));
        if(tipo2 == 'A')
        {
          nombre = this.$store.state.TemisCivil_Catalogos_NombreAutoridad.valor;
        }
        else
        {
          nombre = document.getElementById('nombreDema').value;
          apat = document.getElementById('apatDema').value;
          amat = document.getElementById('amatDema').value;
        }
        //Nombres
        if(!nombre || !apat || !amat)
        {
          nombreCompleto = 'X';
        }else
        {
          if(tipo2 == 'M')
          {
            apat = '';
            amat = '';
          }else
            nombreCompleto = nombre + ' ' + apat + ' ' + amat;
        }
        if(!document.getElementById('radioTerce')){

        }

        return new Array(nombre, apat, amat, tipo1, tipo2);
      },
      ValidaAntesDeAgregarELemento(PrimerValor, SegundoValor)
      {
        var tipo1 = '';
        var tipo2 = '';
        if(this.picked == 'Contencioso' && PrimerValor != 'anexPromo')
        {
          tipo1 = document.getElementById('radioActor').checked ? 'ACTOR' : (document.getElementById('radioDeman').checked ? 'DEMANDADO' : (document.getElementById('radioTerce').checked ? 'TERCERO': 'X'));
          tipo2 = document.getElementById('persFisica').checked ? 'F' : (document.getElementById('persMoral').checked ? 'M' : (document.getElementById('persAutor').checked ? 'A': 'X'));
        }else if(this.picked == 'Familiar' && PrimerValor != 'anexPromo')
        {
          tipo1 = document.getElementById('radioActor').checked ? 'ACTOR' : (document.getElementById('radioDeman').checked ? 'DEMANDADO' : 'X');
          tipo2 = document.getElementById('persFisica').checked ? 'F' : 'X';
        }
        else
        {
          if(PrimerValor != 'anexPromo')
          {
            tipo1 = document.getElementById('radioActor').checked ? 'ACTOR' : (document.getElementById('radioDeman').checked ? 'DEMANDADO' : 'X');
            tipo2 = document.getElementById('persFisica').checked ? 'F' : (document.getElementById('persMoral').checked ? 'M' : 'X');
          }
        }
        var faltantes = '';
         if((PrimerValor == 'persona' && tipo1 == 'X') || (PrimerValor == 'persona' && tipo2 == 'X'))
         {
           faltantes += "Es necesario especificar el tipo persona y tipo personalidad\n";
         }else if(PrimerValor.includes('cmb'))
         {
           var Texto2 = document.getElementById(SegundoValor).value;
           if(Texto2 == '')
           {
             faltantes += "Es necesario especificar la cantidad\n";
           }
           if(PrimerValor.includes('cmb_anex'))
           {
             if(this.parametros_Anexo.anexoId == -1)
             {
              faltantes += "Es necesario especificar un anexo\n";
             }
           }
         }

         if(tipo2 != 'A')
          if(PrimerValor == 'persona' && document.getElementById('nombreDema').value == '')
            faltantes += "Es necesario especificar el nombre\n";

         return faltantes;
      },
      AgregaElementoTabla(Tabla, PrimerValor, SegundoValor, Promociones, datosConsulta){
        var sePuedeAgregar = this.ValidaAntesDeAgregarELemento(PrimerValor, SegundoValor);
        if(sePuedeAgregar == '')
        {
          var nodoTexto1 = '';
          var nodoTexto2 = '';
          var nodoTexto3 = '';
          var nodoTexto4 = '';
          var Texto1 = '';
          var Texto2 = '';
          var tabla = document.getElementById(Tabla).getElementsByTagName('tbody')[0];
          var nuevaFila = tabla.insertRow();
          var valor1 = nuevaFila.insertCell();

          if(!Promociones)
          {
            if(PrimerValor == 'persona')
            {
              var infoPersonas = this.DatosPersonalidad();
              var valoresPersona = infoPersonas[3].toUpperCase() + infoPersonas[4].toUpperCase();
              nodoTexto1 = document.createTextNode(valoresPersona);
              valor1.appendChild(nodoTexto1);
              //Nombre
              var nombrePersona = infoPersonas[0].toUpperCase();
              nodoTexto2 = document.createTextNode(nombrePersona);
              var valor2 = nuevaFila.insertCell();
              valor2.contentEditable = true;
              valor2.appendChild(nodoTexto2);
              //Apellido Paterno
              var apatPersona = infoPersonas[1].toUpperCase();
              nodoTexto3 = document.createTextNode(apatPersona);
              var valor3 = nuevaFila.insertCell();
              valor3.contentEditable = true;
              valor3.appendChild(nodoTexto3);
              //Apellido Materno
              var amatPersona = infoPersonas[2].toUpperCase();
              nodoTexto4 = document.createTextNode(amatPersona);
              var valor4 = nuevaFila.insertCell();
              valor4.contentEditable = true;
              valor4.appendChild(nodoTexto4);
              //Color de la Persona
              if(infoPersonas[3]=='ACTOR')
                nuevaFila.style.backgroundColor="#446600";
              if(infoPersonas[3]=='DEMANDADO')
                nuevaFila.style.backgroundColor="#006bb3";
              if(infoPersonas[3]=='TERCERO')
                nuevaFila.style.backgroundColor="#5c5c3d";
            }if(PrimerValor == 'consultaPersonas')
            {
              nodoTexto1 = document.createTextNode(datosConsulta.DescripcionTipo + datosConsulta.LetraPersonalidad);
              valor1.appendChild(nodoTexto1);
              //Nombre
              nodoTexto2 = document.createTextNode(datosConsulta.Nombre);
              var valor2 = nuevaFila.insertCell();
              valor2.contentEditable = true;
              valor2.appendChild(nodoTexto2);
              //Apellido Paterno
              nodoTexto3 = document.createTextNode(datosConsulta.Apaterno);
              var valor3 = nuevaFila.insertCell();
              valor3.contentEditable = true;
              valor3.appendChild(nodoTexto3);
              //Apellido Materno
              nodoTexto4 = document.createTextNode(datosConsulta.Amaterno);
              var valor4 = nuevaFila.insertCell();
              valor4.contentEditable = true;
              valor4.appendChild(nodoTexto4);
              //Color de la Persona
              if(datosConsulta.DescripcionTipo=='ACTOR')
                nuevaFila.style.backgroundColor="#446600";
              if(datosConsulta.DescripcionTipo=='DEMANDADO')
                nuevaFila.style.backgroundColor="#006bb3";
              if(datosConsulta.DescripcionTipo=='TERCERO')
                nuevaFila.style.backgroundColor="#5c5c3d";
            }else
            {
              if((PrimerValor != 'persona') && (SegundoValor != ''))
              {
                if(PrimerValor.includes('cmb')){
                  Texto1 = this.parametros_Anexo.NombreSeleccion.toUpperCase();
                  nodoTexto1 = document.createTextNode(Texto1);
                }else{
                  Texto1 = document.getElementById(PrimerValor).value.toUpperCase();
                  nodoTexto1 = document.createTextNode(Texto1);
                }
                valor1.contentEditable = true;
                valor1.appendChild(nodoTexto1);
                var valor2 = nuevaFila.insertCell();
                if(SegundoValor.includes('cmb')){
                  Texto2 = document.getElementById(SegundoValor).options[document.getElementById(SegundoValor).selectedIndex].innerHTML.toUpperCase();
                  nodoTexto2 = document.createTextNode(Texto2);
                }else{
                  Texto2 = document.getElementById(SegundoValor).value.toUpperCase();
                  nodoTexto2 = document.createTextNode(Texto2);
                }
                valor2.contentEditable = true;
                valor2.appendChild(nodoTexto2);
              }
            }
          }
          else
          {        
            if(isNaN(PrimerValor))
              nodoTexto1 = document.createTextNode(PrimerValor.toUpperCase());
            else
              nodoTexto1 = document.createTextNode(PrimerValor);
            if(PrimerValor=='ACTOR')
              nuevaFila.style.backgroundColor="#446600";
            if(PrimerValor=='DEMANDADO')
              nuevaFila.style.backgroundColor="#006bb3";
            if(PrimerValor=='TERCERO')
              nuevaFila.style.backgroundColor="#5c5c3d";
            valor1.appendChild(nodoTexto1);
            if(isNaN(SegundoValor))
              nodoTexto2 = document.createTextNode(SegundoValor.toUpperCase());
            else
              nodoTexto2 = document.createTextNode(SegundoValor);
            var valor2 = nuevaFila.insertCell();
            valor2.appendChild(nodoTexto2);
          }
        }else
        {
          alert(sePuedeAgregar);
        }
      },
      QuitaElementoTabla(Tabla){
        var tableRef = document.getElementById(Tabla).getElementsByTagName('tbody')[0];
        tableRef.deleteRow(tableRef.rows.length -1);
      },
      ObtenerListaTabla(idTabla){
        var datos = [];
        var table = document.getElementById(idTabla);
        for (var i = 1, row; row = table.rows[i]; i++) {
           for (var j = 0, col; col = row.cells[j]; j++) {
            datos.push(col.outerText);
           }
        }
        return datos;
      },
      //Borrado lógico de folios
      EliminaFolio(){
        let peticion = {
          IdEqui:0
        }
      axios.post(api.conexion + api.TemisCivil.sistema.Oficialia.Eliminar, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              if (respuesta.data.Satisfactorio != "") {
                comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      validarCapturaNumero: function(e){
        var elemento_Anio = document.getElementById('AnioPromocion').value;
        if(e.which === 13){//Si es enter
          if(e.currentTarget.id == 'AnioPromocion'){
            if(elemento_Anio.length == 4)
            {
              this.ConPromo = this.comprobarMascara(document.getElementById('ConsecutivoPromocion').value);
              if(this.AreaAsignada == '0'){
                alert('Es necesario seleccionar el área a la que pertenece el consecutivo');
              }else{
                this.NumDocumentoProm = this.ConPromo + '/' + this.AnioPromo;
                this.ObtenerDatosExpedientePromocion();
              }
            }else
            {
              alert('El número de documento capturado no es válido');
            }
          }else{
            document.getElementById('AnioPromocion').focus();
          }
        }else{
          var elementoActual = document.getElementById(e.currentTarget.id).value;
          if(elementoActual.length == 4){
            if(e.which != 8 && e.which != 9 && e.which != 37 && e.which != 39){
              e.preventDefault();
              if(e.currentTarget.id == 'ConsecutivoPromocion')
              {
                document.getElementById("AnioPromocion").focus();
                document.getElementById("AnioPromocion").value = e.key;
              }
            }
          }
        }
      },
      comprobarMascara(valorConsecutivo){
        var ceros = "";
        var sigConsecu = "";
        for (var i = 0; i < 4 - valorConsecutivo.length; i++) {
          ceros += "0";
        }
        sigConsecu = ceros + valorConsecutivo;

        return sigConsecu;
      },
      LimpiarFolio: function(e){
        if(!e.target.checked)
        {
          this.Folio_aBuscar = null;
          this.LimpiarControles();
        }
      },
      validarFolio: function(e){
        if(e.keyCode === 13){
          let peticion = {
            TipoDoc : this.tab == 'demanda' ? 1 : (this.tab == 'promociones' ? 3 : this.tipoMensajeria),
            IdeEqui : this.Folio_aBuscar
          }
        this.LimpiarControles();
        axios.post(api.conexion + api.TemisCivil.sistema.Oficialia.InfoDoc, peticion,
        comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }else if(respuesta.data.Borrado){
              comun.mensajeDeAlerta("El folio capturado ha sido borrado", null, null);
            }else if(respuesta.data.Satisfactorio.includes(" no es editable")){
              comun.mensajeDeAlerta("El documento no cumple con los requisitos para edición", null, null);
            }
            else {
              if(respuesta.data.Satisfactorio != "") {
                if(this.tab == 'demanda')
                {
                  this.preDem = respuesta.data.Dem.Presenta;
                  this.Cant = respuesta.data.Dem.Cantidad;
                  this.obsDem = respuesta.data.Dem.Observaciones;
                  this.picked = respuesta.data.Dem.MateriaDem;
                  this.parametros_Juicio.juicioId = respuesta.data.Dem.IdJuicio;
                  this.parametros_Juicio.parametros.materiaId = respuesta.data.Dem.IdMateriaDem;
                  this.parametros_Juicio.key = "Materia_" + respuesta.data.Dem.IdMateriaDem;
                  this.TramiteId = this.parametros_Tramite.tramiteId = respuesta.data.Dem.IdTramite;
                  this.parametros_Tramite.key = "Juicio_" + this.parametros_Juicio.juicioId;
                  respuesta.data.Personalidades.forEach(p => this.AgregaElementoTabla('tablaPersonalidades', 'consultaPersonas', '', false, p));
                  respuesta.data.Anexos.forEach(p => this.AgregaElementoTabla('anexDema', p.Descripcion, p.Cantidad, true, null));
                }
                if(this.tab == 'promociones')
                {
                  this.NumDocumentoProm = respuesta.data.Pro.NumDocu.substring(0,4) + '/' + respuesta.data.Pro.NumDocu.substring(4,8);
                  this.ConPromo = respuesta.data.Pro.NumDocu.substring(0,4);
                  this.AnioPromo = respuesta.data.Pro.NumDocu.substring(4,8);
                  this.tipoPromo = respuesta.data.Pro.TipPromocion;
                  this.cambioAreaPromocion(respuesta.data.Pro.AreaDestino);
                  respuesta.data.Personalidades.forEach(p =>
                    this.AgregaElementoTabla('tablaPromociones', 'consultaPersonas', '', false, p));
                  respuesta.data.Anexos.forEach(p =>this.AgregaElementoTabla('anexPromo', p.Descripcion, p.Cantidad, true, null));
                  this.preProm = respuesta.data.Pro.Presenta;
                  var d = new Date();
                  this.parametros_AreaPromocion.areaPromoId = respuesta.data.Pro.AreaDestino;
                  this.parametros_AreaPromocion.key = "AreaPromo_" + d.getMilliseconds();
                }
                if(this.tab == 'oficios')
                {
                  this.tipoMensajeria = respuesta.data.Men.TipoDoc;
                  this.tipoDoc = respuesta.data.Men.TipoDoc;
                  this.preOfiOtro = respuesta.data.Men.Presenta;
                  this.obsOfiOtro = respuesta.data.Men.Observaciones;
                  this.numOfi = respuesta.data.Men.NumDocu;
                }
                document.getElementById("btnGuardar").innerHTML = "<i class=\"fas fa-save\">Editar</i>";
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
            document.getElementById("btnGuardar").innerHTML = "<i class=\"fas fa-save\">Guardar</i>";
          })
        }
      },
      ObtenerDatosExpedientePromocion(){
        comun.SeEstaCargandoInformacion(true);
        let peticion = {
          Consecutvo: this.ConPromo + '/' + this.AnioPromo,
          TipoDoc: this.tipoPromo,
          IdArea: this.parametros_AreaPromocion.areaPromoId
        }
        axios.post(api.conexion + api.TemisCivil.sistema.Oficialia.InfoPadrePromo, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              if (respuesta.data.Satisfactorio != "") {
                //Limpiar la tabla antes de cargar datos
                this.LimpiarTablas(['tablaPromociones']);
                //Personalidades
                respuesta.data.Personalidades.forEach(p =>
                  this.AgregaElementoTabla('tablaPromociones', p.DescripcionTipo, p.Nombre + ' ' + (p.Apaterno  == null ? '' : p.Apaterno) + ' ' + (p.Amaterno  == null ? '' : p.Amaterno), true
                ));
                comun.SeEstaCargandoInformacion(false);
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.SeEstaCargandoInformacion(false);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      TipoDemandaContencioso(){
        if($("JuicioCon").is(":visible"))
        {
          return document.getElementById("JuicioCon").value;
        }
        else
        {
          return -1;
        }
      },
      EliminarFolio(){
        let peticion = {
          IdEqui:this.Folio_aBuscar
        }
        if(this.Folio_aBuscar != null && this.Folio_aBuscar > 0)
        {
          comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.TemisCivil.sistema.Oficialia.Eliminar, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
              .then(respuesta => {
                if (respuesta.data.SiHayError) {
                  comun.SeEstaCargandoInformacion(false);
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {
                  if (respuesta.data.Satisfactorio != "") {
                    comun.SeEstaCargandoInformacion(false);
                    if(confirm("¿Desea limpiar los campos?"))
                    {
                      this.LimpiarControles();
                    }
                  }
                }
              })
              .catch(excepcion => {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
              })
        }else{
          comun.mensajeDeAlerta("No hay ningún folio para eliminar", null, null);
        }
      },
      //Guardado de la captura en la BD
      GuardarDocumento(){
        if(this.ValidaCampos())
        {
          comun.SeEstaCargandoInformacion(true);
          let peticion = {
            TipDoc : this.tab == 'demanda' ? 1 : (this.tab == 'promociones' ? 3 : this.tipoMensajeria),
            IdEqui: this.BuscarFolio ? this.Folio_aBuscar : 0,
            ConDocu: "",
            AnioDocu: "",
            Observaciones: this.tab == 'demanda' ? this.obsDem.toUpperCase() : (this.tab == 'promociones' ? this.obsProm.toUpperCase() : this.obsOfiOtro.toUpperCase()),
            IdEquiRef: this.tab == 'demanda' ? 0 : (this.tab == 'promociones' ? 9999 : -1),
            Presenta:this.tab == 'demanda' ? this.preDem : (this.tab == 'promociones' ? this.preProm : this.preOfiOtro),
            AreaDestino:this.tab == 'demanda' ? (this.AsignacionDirecta ? this.AsignacionDirecta : (this.MunicipioAsignado)): (this.tab == 'promociones' ? this.parametros_AreaPromocion.areaPromoId : this.AreaAsignada),
            Materia:this.picked,
            Cantidad:this.Cant,
            IdJuicio:this.JuicioId,
            IdTramite:this.TramiteId,
            PersonasEqui:this.tab == 'demanda' ? this.ObtenerListaTabla('tablaPersonalidades') : null,
            AnexosEqui:this.tab == 'demanda' ? this.ObtenerListaTabla('anexDema') : (this.tab == 'promociones' ? this.ObtenerListaTabla('anexPromo') : this.ObtenerListaTabla('anexOficio')),
            TipCantidad:this.Cambio,
            TipPromocion:this.tipoPromo,
            ConsecutivoPadre:this.NumDocumentoProm,
            TipContencioso:this.TipoDemandaContencioso(),
            Origen:this.OrigenOficio,
            NumDocu:this.numOfi
          }
          axios.post(api.conexion + api.TemisCivil.sistema.Oficialia.Guardado, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
              if (respuesta.data.SiHayError) {
                document.getElementById("btnGuardar").innerHTML = "<i class=\"fas fa-save\">Guardar</i>"
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
              } else {
                if (respuesta.data.Satisfactorio != "") {
                  comun.SeEstaCargandoInformacion(false);
                  if(confirm("¿Desea limpiar los campos?"))
                  {
                    this.LimpiarControles();
                  }
                  document.getElementById("btnGuardar").innerHTML = "<i class=\"fas fa-save\">Guardar</i>"
                  this.ImprimeRecibo(respuesta.data.IdNuevoDoc);
                }
              }
            })
            .catch(excepcion => {
              console.log(excepcion);
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
              document.getElementById("btnGuardar").innerHTML = "<i class=\"fas fa-save\">Guardar</i>";
            })
        }
      }
    },
    created() {
    },
    mounted(){
    }
  }
</script>

<style scoped>
  h3 {
    font-size: 18px;
    border-bottom: 2px solid #FFF;
    padding-bottom: 8px;
    margin-bottom: 12px;
  }

  tr {
    color: #fff;
    background: black;
  }

  td {
    color: #fff;
    background: black;
  }

  input {
    padding: 0.2em;
    box-sizing: border-box;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/TemisCivil/OficialiaDePartes/RecepcionTC.vue